import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

// No need for ProtectedRouteProps anymore as we're using Outlet
const ProtectedRoute: React.FC = () => {
  const { currentUser, loading } = useAuth();

  // Show loading indicator while checking authentication status
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // If not authenticated, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // If authenticated, render the Outlet (child routes)
  return <Outlet />;
};

export default ProtectedRoute;
